import { inject } from '@angular/core';
import { ExhibitorService } from '@core/data-access/services/exhibitor/exhibitor.service';
import { ExhibitorActions } from '@core/data-access/store/exhibitor/exhibitor.actions';
import { selectExhibitorDetailByCompanyTriple } from '@core/data-access/store/exhibitor/exhibitor.selectors';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { filter, map } from 'rxjs';

export const setExhibitorDetailAfterVoucherRedeem$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), exhibitorService = inject(ExhibitorService)) =>
    actions$.pipe(
      ofType(ExhibitorActions.setExhibitorDetailAfterVoucherRedeem),
      filter(({ exhibitorDetail, hasSponsorArea }) => !isEmpty(exhibitorDetail) && hasSponsorArea),
      concatLatestFrom(({ exhibitorDetail }) =>
        store.select(selectExhibitorDetailByCompanyTriple(exhibitorDetail.companyTriple))
      ),
      filter(([_, storedExhibitorDetail]) => isEmpty(storedExhibitorDetail)),
      map(([{ exhibitorDetail }]) => {
        const isExhibitorWelcomeMessageModalOpen =
          !exhibitorService.isEmptyExhibitorWelcomeMessageModal(exhibitorDetail);

        return ExhibitorActions.setExhibitorDetail({ exhibitorDetail, isExhibitorWelcomeMessageModalOpen });
      })
    ),
  { functional: true }
);
